export const SeaConfigActionTypes = {
  API_RESPONSE_SUCCESS: '@@sea-config/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@sea-config/API_RESPONSE_ERROR',

  GET_SEA_CONFIG: '@@sea-config/GET_SEA_CONFIG',
  LIST_SEA_CONFIGS: '@@sea-config/LIST_SEA_CONFIGS',
  ADD_SEA_CONFIG: '@@sea-config/ADD_SEA_CONFIG',
  UPDATE_SEA_CONFIG: '@@sea-config/UPDATE_SEA_CONFIG',
  DELETE_SEA_CONFIG: '@@sea-config/DELETE_SEA_CONFIG',
  SET_FILTER: '@@sea-config/SET_FILTER',

  RESET: '@@sea-config/RESET'
}
